module.exports = "/images/facebook-icon.svg";